/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetMediaListResponse,
  GetMediaListsResponse,
  GetOurMediaListMediaOutletsResponse,
  GetPrtimesMediaListMediaOutletsResponse,
  ModelError,
  PostOurMediaListBody,
  PostPrtimesMediaListBody,
} from '../models';
import {
    GetMediaListResponseFromJSON,
    GetMediaListResponseToJSON,
    GetMediaListsResponseFromJSON,
    GetMediaListsResponseToJSON,
    GetOurMediaListMediaOutletsResponseFromJSON,
    GetOurMediaListMediaOutletsResponseToJSON,
    GetPrtimesMediaListMediaOutletsResponseFromJSON,
    GetPrtimesMediaListMediaOutletsResponseToJSON,
    ModelErrorFromJSON,
    ModelErrorToJSON,
    PostOurMediaListBodyFromJSON,
    PostOurMediaListBodyToJSON,
    PostPrtimesMediaListBodyFromJSON,
    PostPrtimesMediaListBodyToJSON,
} from '../models';

export interface CopyMediaListRequest {
    run: CopyMediaListRunEnum;
    page: CopyMediaListPageEnum;
    masterId: number;
    mode: CopyMediaListModeEnum;
    newName: string;
}

export interface DeleteImportedMediaListRequest {
    masterId: number;
    ajax: DeleteImportedMediaListAjaxEnum;
}

export interface DeletePrtimesMediaListRequest {
    masterId: number;
    ajax: DeletePrtimesMediaListAjaxEnum;
}

export interface GetActionPhpRequest {
    run: GetActionPhpRunEnum;
    page: GetActionPhpPageEnum;
    ajax: number;
    masterId: number;
    releaseMediaId?: number;
    autoNo?: number;
}

export interface GetIsInvalidMediaListNameRequest {
    type: GetIsInvalidMediaListNameTypeEnum;
    name: string;
}

export interface GetOurMediaListRequest {
    mediaListId: number;
}

export interface GetOurMediaListMediaOutletsRequest {
    mediaListId: number;
    perPage?: number;
    page?: number;
    fields?: string;
    isOnlyUnsubscription?: boolean;
    dangerouslyFetchAllMediaOutlets?: boolean;
}

export interface GetOurMediaListsRequest {
    perPage?: number;
    page?: number;
    fields?: string;
}

export interface GetPrtimesMediaListRequest {
    mediaListId: number;
}

export interface GetPrtimesMediaListMediaOutletsRequest {
    mediaListId: number;
    perPage?: number;
    page?: number;
    fields?: string;
}

export interface GetPrtimesMediaListsRequest {
    perPage?: number;
    page?: number;
    fields?: string;
}

export interface PostOurMediaListRequest {
    mediaListId: number;
    postOurMediaListBody?: PostOurMediaListBody;
}

export interface PostPrtimesMediaListRequest {
    mediaListId: number;
    postPrtimesMediaListBody?: PostPrtimesMediaListBody;
}

export interface UpdateOurMediaOutletRequest {
    mediaTypeId: string;
    mediaName: string;
    companyName: string;
    firstName: string;
    dept: string;
    releaseMail: string;
    phone: string;
    releaseFax: string;
    companyId: number;
    makeKbn: number;
    autoNo: number;
    releaseMediaId: number;
    masterId: number;
}

/**
 * 
 */
export class MediaListApi extends runtime.BaseAPI {

    /**
     * メディアリストをコピーするAPI
     * レガシーコードにおけるメディアリストのコピー用API
     */
    async copyMediaListRaw(requestParameters: CopyMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.run === null || requestParameters.run === undefined) {
            throw new runtime.RequiredError('run','Required parameter requestParameters.run was null or undefined when calling copyMediaList.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling copyMediaList.');
        }

        if (requestParameters.masterId === null || requestParameters.masterId === undefined) {
            throw new runtime.RequiredError('masterId','Required parameter requestParameters.masterId was null or undefined when calling copyMediaList.');
        }

        if (requestParameters.mode === null || requestParameters.mode === undefined) {
            throw new runtime.RequiredError('mode','Required parameter requestParameters.mode was null or undefined when calling copyMediaList.');
        }

        if (requestParameters.newName === null || requestParameters.newName === undefined) {
            throw new runtime.RequiredError('newName','Required parameter requestParameters.newName was null or undefined when calling copyMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.run !== undefined) {
            formParams.append('run', requestParameters.run as any);
        }

        if (requestParameters.page !== undefined) {
            formParams.append('page', requestParameters.page as any);
        }

        if (requestParameters.masterId !== undefined) {
            formParams.append('master_id', requestParameters.masterId as any);
        }

        if (requestParameters.mode !== undefined) {
            formParams.append('mode', requestParameters.mode as any);
        }

        if (requestParameters.newName !== undefined) {
            formParams.append('new_name', requestParameters.newName as any);
        }

        const response = await this.request({
            path: `/my_c3/action.php`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * メディアリストをコピーするAPI
     * レガシーコードにおけるメディアリストのコピー用API
     */
    async copyMediaList(requestParameters: CopyMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.copyMediaListRaw(requestParameters, initOverrides);
    }

    /**
     * インポートされたメディアリストを削除するAPI
     * レガシーコードにおけるインポートされたメディアリスト削除API
     */
    async deleteImportedMediaListRaw(requestParameters: DeleteImportedMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.masterId === null || requestParameters.masterId === undefined) {
            throw new runtime.RequiredError('masterId','Required parameter requestParameters.masterId was null or undefined when calling deleteImportedMediaList.');
        }

        if (requestParameters.ajax === null || requestParameters.ajax === undefined) {
            throw new runtime.RequiredError('ajax','Required parameter requestParameters.ajax was null or undefined when calling deleteImportedMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.masterId !== undefined) {
            formParams.append('master_id', requestParameters.masterId as any);
        }

        if (requestParameters.ajax !== undefined) {
            formParams.append('ajax', requestParameters.ajax as any);
        }

        const response = await this.request({
            path: `/my_c3/mypage/registmylistmasterdelete_action`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * インポートされたメディアリストを削除するAPI
     * レガシーコードにおけるインポートされたメディアリスト削除API
     */
    async deleteImportedMediaList(requestParameters: DeleteImportedMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deleteImportedMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PR TIMES メディアリストを削除するAPI
     * レガシーコードにおけるPR TIMESメディアリスト削除API
     */
    async deletePrtimesMediaListRaw(requestParameters: DeletePrtimesMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.masterId === null || requestParameters.masterId === undefined) {
            throw new runtime.RequiredError('masterId','Required parameter requestParameters.masterId was null or undefined when calling deletePrtimesMediaList.');
        }

        if (requestParameters.ajax === null || requestParameters.ajax === undefined) {
            throw new runtime.RequiredError('ajax','Required parameter requestParameters.ajax was null or undefined when calling deletePrtimesMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.masterId !== undefined) {
            formParams.append('master_id', requestParameters.masterId as any);
        }

        if (requestParameters.ajax !== undefined) {
            formParams.append('ajax', requestParameters.ajax as any);
        }

        const response = await this.request({
            path: `/my_c3/mypage/registsendlistdelete_action`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * PR TIMES メディアリストを削除するAPI
     * レガシーコードにおけるPR TIMESメディアリスト削除API
     */
    async deletePrtimesMediaList(requestParameters: DeletePrtimesMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deletePrtimesMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * レガシーコードにおけるaction.phpへのGETリクエスト
     */
    async getActionPhpRaw(requestParameters: GetActionPhpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.run === null || requestParameters.run === undefined) {
            throw new runtime.RequiredError('run','Required parameter requestParameters.run was null or undefined when calling getActionPhp.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getActionPhp.');
        }

        if (requestParameters.ajax === null || requestParameters.ajax === undefined) {
            throw new runtime.RequiredError('ajax','Required parameter requestParameters.ajax was null or undefined when calling getActionPhp.');
        }

        if (requestParameters.masterId === null || requestParameters.masterId === undefined) {
            throw new runtime.RequiredError('masterId','Required parameter requestParameters.masterId was null or undefined when calling getActionPhp.');
        }

        const queryParameters: any = {};

        if (requestParameters.run !== undefined) {
            queryParameters['run'] = requestParameters.run;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.ajax !== undefined) {
            queryParameters['ajax'] = requestParameters.ajax;
        }

        if (requestParameters.masterId !== undefined) {
            queryParameters['master_id'] = requestParameters.masterId;
        }

        if (requestParameters.releaseMediaId !== undefined) {
            queryParameters['release_media_id'] = requestParameters.releaseMediaId;
        }

        if (requestParameters.autoNo !== undefined) {
            queryParameters['auto_no'] = requestParameters.autoNo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/my_c3/action.php`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * レガシーコードにおけるaction.phpへのGETリクエスト
     */
    async getActionPhp(requestParameters: GetActionPhpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getActionPhpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * レガシーコードにおけるメディアリスト名の検証用API
     */
    async getIsInvalidMediaListNameRaw(requestParameters: GetIsInvalidMediaListNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling getIsInvalidMediaListName.');
        }

        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling getIsInvalidMediaListName.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/company_medialist_duplicate_name.php`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * レガシーコードにおけるメディアリスト名の検証用API
     */
    async getIsInvalidMediaListName(requestParameters: GetIsInvalidMediaListNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getIsInvalidMediaListNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 各企業が自社で作成されたメディアリストの詳細を取得するためのAPI
     * Get Our Media List
     */
    async getOurMediaListRaw(requestParameters: GetOurMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMediaListResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling getOurMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/media_list/our_media_lists/{media_list_id}`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMediaListResponseFromJSON(jsonValue));
    }

    /**
     * 各企業が自社で作成されたメディアリストの詳細を取得するためのAPI
     * Get Our Media List
     */
    async getOurMediaList(requestParameters: GetOurMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMediaListResponse> {
        const response = await this.getOurMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 各企業が自社で作成されたメディアリストのメディア一覧を取得するためのAPI
     * Get media outlets in the Our-Media-List
     */
    async getOurMediaListMediaOutletsRaw(requestParameters: GetOurMediaListMediaOutletsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOurMediaListMediaOutletsResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling getOurMediaListMediaOutlets.');
        }

        const queryParameters: any = {};

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.isOnlyUnsubscription !== undefined) {
            queryParameters['is_only_unsubscription'] = requestParameters.isOnlyUnsubscription;
        }

        if (requestParameters.dangerouslyFetchAllMediaOutlets !== undefined) {
            queryParameters['dangerously_fetch_all_media_outlets'] = requestParameters.dangerouslyFetchAllMediaOutlets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/media_list/our_media_lists/{media_list_id}/media_outlets`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOurMediaListMediaOutletsResponseFromJSON(jsonValue));
    }

    /**
     * 各企業が自社で作成されたメディアリストのメディア一覧を取得するためのAPI
     * Get media outlets in the Our-Media-List
     */
    async getOurMediaListMediaOutlets(requestParameters: GetOurMediaListMediaOutletsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOurMediaListMediaOutletsResponse> {
        const response = await this.getOurMediaListMediaOutletsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 各企業が自社で作成したメディアリスト一覧を取得するためのAPI
     * Get Our Media Lists
     */
    async getOurMediaListsRaw(requestParameters: GetOurMediaListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMediaListsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/media_list/our_media_lists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMediaListsResponseFromJSON(jsonValue));
    }

    /**
     * 各企業が自社で作成したメディアリスト一覧を取得するためのAPI
     * Get Our Media Lists
     */
    async getOurMediaLists(requestParameters: GetOurMediaListsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMediaListsResponse> {
        const response = await this.getOurMediaListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PR TIMES で作成されたメディアリストの詳細を取得するためのAPI
     * Get PR TIMES\'s Media List
     */
    async getPrtimesMediaListRaw(requestParameters: GetPrtimesMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMediaListResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling getPrtimesMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/media_list/prtimes_media_lists/{media_list_id}`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMediaListResponseFromJSON(jsonValue));
    }

    /**
     * PR TIMES で作成されたメディアリストの詳細を取得するためのAPI
     * Get PR TIMES\'s Media List
     */
    async getPrtimesMediaList(requestParameters: GetPrtimesMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMediaListResponse> {
        const response = await this.getPrtimesMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 各企業が自社で作成されたメディアリストのメディア一覧を取得するためのAPI
     * Get all media outlets in the PRTimes-Media-List
     */
    async getPrtimesMediaListMediaOutletsRaw(requestParameters: GetPrtimesMediaListMediaOutletsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrtimesMediaListMediaOutletsResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling getPrtimesMediaListMediaOutlets.');
        }

        const queryParameters: any = {};

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/media_list/prtimes_media_lists/{media_list_id}/media_outlets`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrtimesMediaListMediaOutletsResponseFromJSON(jsonValue));
    }

    /**
     * 各企業が自社で作成されたメディアリストのメディア一覧を取得するためのAPI
     * Get all media outlets in the PRTimes-Media-List
     */
    async getPrtimesMediaListMediaOutlets(requestParameters: GetPrtimesMediaListMediaOutletsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrtimesMediaListMediaOutletsResponse> {
        const response = await this.getPrtimesMediaListMediaOutletsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PR TIMES で作成されたメディアリスト一覧を取得するためのAPI
     * Get PR TIMES\'s Media Lists
     */
    async getPrtimesMediaListsRaw(requestParameters: GetPrtimesMediaListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMediaListsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/media_list/prtimes_media_lists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMediaListsResponseFromJSON(jsonValue));
    }

    /**
     * PR TIMES で作成されたメディアリスト一覧を取得するためのAPI
     * Get PR TIMES\'s Media Lists
     */
    async getPrtimesMediaLists(requestParameters: GetPrtimesMediaListsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMediaListsResponse> {
        const response = await this.getPrtimesMediaListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 各企業が自社で作成されたメディアリストの詳細を更新するためのAPI
     * Update Our Media List
     */
    async postOurMediaListRaw(requestParameters: PostOurMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMediaListResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling postOurMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/media_list/our_media_lists/{media_list_id}`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostOurMediaListBodyToJSON(requestParameters.postOurMediaListBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMediaListResponseFromJSON(jsonValue));
    }

    /**
     * 各企業が自社で作成されたメディアリストの詳細を更新するためのAPI
     * Update Our Media List
     */
    async postOurMediaList(requestParameters: PostOurMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMediaListResponse> {
        const response = await this.postOurMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PR TIMES で作成されたメディアリストの詳細を更新するためのAPI
     * Update PR TIMES\'s Media List
     */
    async postPrtimesMediaListRaw(requestParameters: PostPrtimesMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMediaListResponse>> {
        if (requestParameters.mediaListId === null || requestParameters.mediaListId === undefined) {
            throw new runtime.RequiredError('mediaListId','Required parameter requestParameters.mediaListId was null or undefined when calling postPrtimesMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/media_list/prtimes_media_lists/{media_list_id}`.replace(`{${"media_list_id"}}`, encodeURIComponent(String(requestParameters.mediaListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostPrtimesMediaListBodyToJSON(requestParameters.postPrtimesMediaListBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMediaListResponseFromJSON(jsonValue));
    }

    /**
     * PR TIMES で作成されたメディアリストの詳細を更新するためのAPI
     * Update PR TIMES\'s Media List
     */
    async postPrtimesMediaList(requestParameters: PostPrtimesMediaListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMediaListResponse> {
        const response = await this.postPrtimesMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * レガシーコードにおける自社メディアリスト内のメディア編集API
     */
    async updateOurMediaOutletRaw(requestParameters: UpdateOurMediaOutletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.mediaTypeId === null || requestParameters.mediaTypeId === undefined) {
            throw new runtime.RequiredError('mediaTypeId','Required parameter requestParameters.mediaTypeId was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.mediaName === null || requestParameters.mediaName === undefined) {
            throw new runtime.RequiredError('mediaName','Required parameter requestParameters.mediaName was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.companyName === null || requestParameters.companyName === undefined) {
            throw new runtime.RequiredError('companyName','Required parameter requestParameters.companyName was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.firstName === null || requestParameters.firstName === undefined) {
            throw new runtime.RequiredError('firstName','Required parameter requestParameters.firstName was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.dept === null || requestParameters.dept === undefined) {
            throw new runtime.RequiredError('dept','Required parameter requestParameters.dept was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.releaseMail === null || requestParameters.releaseMail === undefined) {
            throw new runtime.RequiredError('releaseMail','Required parameter requestParameters.releaseMail was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.phone === null || requestParameters.phone === undefined) {
            throw new runtime.RequiredError('phone','Required parameter requestParameters.phone was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.releaseFax === null || requestParameters.releaseFax === undefined) {
            throw new runtime.RequiredError('releaseFax','Required parameter requestParameters.releaseFax was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.makeKbn === null || requestParameters.makeKbn === undefined) {
            throw new runtime.RequiredError('makeKbn','Required parameter requestParameters.makeKbn was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.autoNo === null || requestParameters.autoNo === undefined) {
            throw new runtime.RequiredError('autoNo','Required parameter requestParameters.autoNo was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.releaseMediaId === null || requestParameters.releaseMediaId === undefined) {
            throw new runtime.RequiredError('releaseMediaId','Required parameter requestParameters.releaseMediaId was null or undefined when calling updateOurMediaOutlet.');
        }

        if (requestParameters.masterId === null || requestParameters.masterId === undefined) {
            throw new runtime.RequiredError('masterId','Required parameter requestParameters.masterId was null or undefined when calling updateOurMediaOutlet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.mediaTypeId !== undefined) {
            formParams.append('media_type_id', requestParameters.mediaTypeId as any);
        }

        if (requestParameters.mediaName !== undefined) {
            formParams.append('media_name', requestParameters.mediaName as any);
        }

        if (requestParameters.companyName !== undefined) {
            formParams.append('company_name', requestParameters.companyName as any);
        }

        if (requestParameters.firstName !== undefined) {
            formParams.append('first_name', requestParameters.firstName as any);
        }

        if (requestParameters.dept !== undefined) {
            formParams.append('dept', requestParameters.dept as any);
        }

        if (requestParameters.releaseMail !== undefined) {
            formParams.append('release_mail', requestParameters.releaseMail as any);
        }

        if (requestParameters.phone !== undefined) {
            formParams.append('phone', requestParameters.phone as any);
        }

        if (requestParameters.releaseFax !== undefined) {
            formParams.append('release_fax', requestParameters.releaseFax as any);
        }

        if (requestParameters.companyId !== undefined) {
            formParams.append('company_id', requestParameters.companyId as any);
        }

        if (requestParameters.makeKbn !== undefined) {
            formParams.append('make_kbn', requestParameters.makeKbn as any);
        }

        if (requestParameters.autoNo !== undefined) {
            formParams.append('auto_no', requestParameters.autoNo as any);
        }

        if (requestParameters.releaseMediaId !== undefined) {
            formParams.append('release_media_id', requestParameters.releaseMediaId as any);
        }

        if (requestParameters.masterId !== undefined) {
            formParams.append('master_id', requestParameters.masterId as any);
        }

        const response = await this.request({
            path: `/api/company_medialist_edit.php`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * レガシーコードにおける自社メディアリスト内のメディア編集API
     */
    async updateOurMediaOutlet(requestParameters: UpdateOurMediaOutletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOurMediaOutletRaw(requestParameters, initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum CopyMediaListRunEnum {
    Mypage = 'mypage'
}
/**
  * @export
  * @enum {string}
  */
export enum CopyMediaListPageEnum {
    Registsendlistcopy = 'registsendlistcopy',
    Registmylistcopy = 'registmylistcopy'
}
/**
  * @export
  * @enum {string}
  */
export enum CopyMediaListModeEnum {
    NUMBER_1 = 1
}
/**
  * @export
  * @enum {string}
  */
export enum DeleteImportedMediaListAjaxEnum {
    NUMBER_1 = 1
}
/**
  * @export
  * @enum {string}
  */
export enum DeletePrtimesMediaListAjaxEnum {
    NUMBER_1 = 1
}
/**
  * @export
  * @enum {string}
  */
export enum GetActionPhpRunEnum {
    Mypage = 'mypage'
}
/**
  * @export
  * @enum {string}
  */
export enum GetActionPhpPageEnum {
    RegistmylistDelete = 'registmylist_delete',
    RegistsendlistDelete = 'registsendlist_delete'
}
/**
  * @export
  * @enum {string}
  */
export enum GetIsInvalidMediaListNameTypeEnum {
    Prtimes = 'prtimes',
    Mylist = 'mylist'
}
